/* Digital Turn — ShopElmore product-card runtime • Phase 4 • 12 Sep 2026 */
(function(){
  if(window.__DT_ELMORE_GRID__) return;
  window.__DT_ELMORE_GRID__=true;

  function initGrid(){
    document.querySelectorAll('.elmore-card').forEach(function(card){
      if(card.dataset.dtGridReady==='1') return;
      card.dataset.dtGridReady='1';

      const buttons=card.querySelectorAll('.variant-button');
      const productLink=card.querySelector('a[href*="/products/"]');
      const priceEl=card.querySelector('[data-product-price]');
      const delayTagEl=card.querySelector('[data-delay-tag]');
      const dataEl=card.querySelector('.variant-data');
      const img=card.querySelector('.elmore-card__image-main');
      const idInput=card.querySelector('form.elmore-card__quickform input[name="id"]');
      const minus=card.querySelector('[data-qty-down]');
      const plus=card.querySelector('[data-qty-up]');
      const input=card.querySelector('.elmore-qty__input');
      const saleBox=card.querySelector('.sale-box[data-sale-badge]')||card.querySelector('.sale-box');
      const offerBadge=card.querySelector('[data-offer-badge]');
      const bxgyBox=card.querySelector('[data-bxgy]');
      const bxgyMsg=card.querySelector('[data-bxgy-msg]');
      const bxgyFill=card.querySelector('.elmore-b2g1__fill');

      if(!priceEl||!dataEl||!img||!idInput||!input) return;

      let map={};
      try{map=JSON.parse(dataEl.textContent);}catch(e){map={};}
      let serumMap={};
      const serumMapEl=card.querySelector('.serum-amount-off-map');
      try{serumMap=serumMapEl?JSON.parse(serumMapEl.textContent):{};}catch(e){serumMap={};}
      const isSerum=card.getAttribute('data-is-serum')==='true';
      const dtSkuDelayList=['ElmoreChamomileGlycerineBodyLotion400Ml'];

      function updateDelayTag(vid){
        if(!delayTagEl||!map[vid]) return;
        const sku=map[vid].sku||'';
        delayTagEl.style.display=dtSkuDelayList.indexOf(sku)!==-1?'inline-flex':'none';
      }

      const templateText=(priceEl.textContent||'').trim();
      function formatCents(cents){
        const abs=Math.round(Number(cents)||0);
        const num=(abs/100).toLocaleString(undefined,{minimumFractionDigits:abs%100?2:0,maximumFractionDigits:2});
        const m=templateText.match(/^(\D*)(?:-?[\d\s,\.]+)(\D*)$/)||['','',''];
        return ((m[1]||'')+num+(m[2]||'')).trim();
      }

      let unitCents=0;
      function updateDisplayedPrice(){
        const qty=Math.max(1,parseInt(input.value||'1',10));
        priceEl.textContent=formatCents(unitCents*qty);
      }

      function updateOffer(vid){
        if(!map[vid]) return;
        const data=map[vid];
        const type=data.b2g1?'b2g1':(data.b1g1?'b1g1':'');

        if(offerBadge){
          offerBadge.classList.remove('badge-box--b1g1','badge-box--b2g1');
          if(!type){offerBadge.hidden=true;offerBadge.style.display='none';}
          else{
            offerBadge.hidden=false;offerBadge.style.display='';
            offerBadge.classList.add(type==='b2g1'?'badge-box--b2g1':'badge-box--b1g1');
            offerBadge.textContent=type==='b2g1'?'BUY 2 GET 1 FREE':'BUY 1 GET 1 FREE';
          }
        }

        if(!bxgyBox||!bxgyMsg||!bxgyFill) return;
        if(!type){bxgyBox.hidden=true;bxgyBox.style.display='none';return;}
        bxgyBox.hidden=false;bxgyBox.style.display='';
        bxgyBox.dataset.offerType=type;
        bxgyBox.dataset.dealBuy=type==='b2g1'?'2':'1';
        bxgyBox.dataset.dealGet='1';

        const BUY=Number(bxgyBox.dataset.dealBuy);
        const q=Math.max(1,parseInt(input.value||'1',10));
        const freebies=Math.floor(q/BUY);
        const remainder=q%BUY;
        const pct=BUY===1?100:(remainder===0?100:Math.round((remainder/BUY)*100));
        if(freebies>0) bxgyMsg.textContent=freebies===1?'1 FREE unlocked':freebies+' FREE unlocked';
        else bxgyMsg.textContent='Add '+(BUY-remainder)+' more → 1 FREE';
        bxgyFill.style.width=pct+'%';
      }

      function updateSaleBadge(vid){
        if(!saleBox||!map[vid]) return;
        const data=map[vid];
        const priceCents=Number(data.price_cents||0);
        const compareCents=Number(data.compare_at_price_cents||0);
        if(compareCents>priceCents&&compareCents>0){
          const vTitle=(data.title||'').trim();
          const amt=(isSerum&&vTitle&&serumMap&&serumMap[vTitle]!=null)?serumMap[vTitle]:null;
          if(amt!=null) saleBox.textContent='Rs '+amt+' OFF';
          else if(isSerum) saleBox.textContent='Rs '+Math.round(Math.max(0,compareCents-priceCents)/100)+' OFF';
          else saleBox.textContent=Math.round(((compareCents-priceCents)/compareCents)*100)+'% OFF';
          saleBox.style.display='';
        }else saleBox.style.display='none';
      }

      const initVid=idInput.value;
      if(map[initVid]) unitCents=map[initVid].price_cents||0;
      updateDisplayedPrice();updateOffer(initVid);updateSaleBadge(initVid);updateDelayTag(initVid);

      buttons.forEach(function(btn){
        btn.addEventListener('click',function(){
          const vid=this.getAttribute('data-variant-id');
          buttons.forEach(function(b){b.classList.remove('active');b.setAttribute('aria-pressed','false');});
          this.classList.add('active');this.setAttribute('aria-pressed','true');
          idInput.value=vid;
          if(productLink){const base=productLink.getAttribute('href').split('?')[0];productLink.setAttribute('href',base+'?variant='+vid);}
          if(map[vid]){
            unitCents=map[vid].price_cents||unitCents;
            img.style.opacity=0;
            setTimeout(function(){
              const src=map[vid].image;
              img.src=src;
              img.srcset=src+' 600w, '+src.replace('600x600','900x900')+' 900w, '+src.replace('600x600','1200x1200')+' 1200w, '+src.replace('600x600','1500x1500')+' 1500w, '+src.replace('600x600','master')+' 2000w';
              requestAnimationFrame(function(){img.style.opacity=1;});
            },200);
          }
          updateDisplayedPrice();updateOffer(vid);updateSaleBadge(vid);updateDelayTag(vid);
        });
      });

      input.addEventListener('wheel',function(e){e.preventDefault();},{passive:false});
      input.addEventListener('input',function(){
        input.value=input.value.replace(/[^\d]/g,'')||'1';
        updateDisplayedPrice();updateOffer(idInput.value);
      });
      if(minus) minus.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();if(e.stopImmediatePropagation)e.stopImmediatePropagation();
        input.stepDown();const min=parseInt(input.getAttribute('min')||'1',10);if(!input.value||Number(input.value)<min)input.value=String(min);
        updateDisplayedPrice();updateOffer(idInput.value);
      });
      if(plus) plus.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();if(e.stopImmediatePropagation)e.stopImmediatePropagation();
        input.stepUp();if(!input.value)input.value='1';updateDisplayedPrice();updateOffer(idInput.value);
      });
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initGrid,{once:true});
  else initGrid();

  document.addEventListener('shopify:section:load',initGrid);
})();
